<script>
import {getMaterialDetailApi, setReadMaterialId} from '../../../api/technology'
import {getShareInfo} from '../../../utils/wxShare'
import withRouteTracking from '../../../utils/withRouteTracking'
import returnBack from '@/views/person/components/returnBack.vue'
import footerCom from '@/views/article/components/footerCom.vue'
import {articleLike, articleUnLike, articleUnUserCollect, articleUserCollect} from '../../../api/article'
import VideoPlayerAnswer from '@/views/home/components/VideoPlayerAnswer.vue'
import {dictionaryList} from '../../../api/api'

const TechnologyDetail = {
  name: 'detail',
  components: {
    returnBack,
    footerCom,
    VideoPlayerAnswer
  },
  data() {
    return {
      detail: {},
      fileId: '',
      shareDesc: {
        '1444290': '5月24日 12：45 不见不散！'
      },
      videoList: {}
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    isImage() {
      return ['jpg', 'png', 'jpeg', 'gif'].includes(this.detail.materialType)
    },
    isVideo() {
      return ['mp4', 'avi', 'wmv', 'rmvb', 'flv', 'mkv'].includes(this.detail.materialType)
    },
    curKind() {
      switch (this.detail.firstClassify) {
        case '术式方案':
          return '9'
        case '技术前沿':
          return '10'
        case '专科发展':
          return '11'
        case '诊疗发展':
          return '12'
      }
    }
  },
  async created() {
    const {fileId, entrance} = this.$route.query
    if (!fileId) return
    if (entrance === '20' || entrance === '21' || entrance === '68') {
      sessionStorage.setItem('isShare', '1')
    }
    this.fileId = fileId
    window.sessionStorage.setItem('mainId', fileId)
    window.sessionStorage.setItem('serviceId', fileId)
    window.sessionStorage.setItem('entrance', entrance || '')
    setReadMaterialId(this.fileId)
    await this.getDetail()
    await this.getVideoList()
    window.sessionStorage.setItem('traceTitle', '新技术专区详情-' + this.detail.firstClassify + this.detail.materialName)
    document.title = this.detail.firstClassify
    if (Object.keys(this.shareDesc).includes(fileId)) {
      getShareInfo({
        title: this.detail.materialName,
        titleTimeLine: this.detail.materialName,
        desc: this.shareDesc[fileId],
        link: window.location.href,
        linkTimeLine: window.location.href,
        images: this.detail.materialThumbnail,
      })
    } else {
      getShareInfo({
        title: this.detail.materialName,
        titleTimeLine: this.detail.materialName,
        desc: '',
        link: window.location.href,
        linkTimeLine: window.location.href,
        images: this.detail.materialThumbnail,
      })
    }
  },
  methods: {
    // 获取视频列表
    async getVideoList() {
      let {code, data} = await dictionaryList({
        typeCode: 'TECHNOLOGY_FRONTIER_TYPE',
        dataStatus: '1'
      })
      if (code === 0) {
        this.videoList = JSON.parse(data[0].explainContent)
      }
    },

    async getDetail() {
      try {
        const {code, data} = await getMaterialDetailApi(this.fileId)
        if (code === 0) {
          this.detail = data
        }
      } catch (e) {
        throw e
      }
    },
    // 点赞
    handleLike() {
      if (this.detail.isLike) {
        const params = {
          userId: this.userInfo.id,
          baseId: this.fileId,
          type: 12,
          kind: this.curKind
        }
        articleUnLike(params).then(res => {
          if (res.code === 0) {
            this.$toast('取消点赞成功')
            this.getDetail()
          }
        })
      } else {
        const params = {
          type: 12,
          likeId: this.fileId,
          likeTitle: this.detail.materialName,
          userId: this.userInfo.id,
          openId: this.userInfo.iepOpenId,
          cover: this.detail.materialThumbnail,
          kind: this.curKind,
        }
        articleLike(params).then(res => {
          if (res.code === 0) {
            this.$toast('点赞成功')
            this.getDetail()
          }
        })
      }
    },
    // 收藏
    handleCollect() {
      if (this.detail.isCollect) {
        const params = {
          baseId: this.fileId,
          baseType: 8,
          userId: this.userInfo.id,
          userName: this.userInfo.realName
        }
        articleUnUserCollect(params).then(res => {
          if (res.code === 0) {
            this.$toast('取消收藏成功')
            this.getDetail()
          }
        })
      } else {
        const params = {
          userId: this.userInfo.id,
          baseId: this.fileId,
          baseType: 8,
        }
        articleUserCollect(params).then(res => {
          if (res.code === 0) {
            this.$toast('收藏成功')
            this.getDetail()
          }
        })
      }
    },
    goBack() {
      const {firstClassify} = this.detail
      const {entrance} = this.$route.query

      // 提取分类映射逻辑为独立函数，便于复用和测试
      function mapFirstClassify(classify) {
        const mapping = {
          '术式方案': '1',
          '技术前沿': '2',
          '专科发展': '3',
          '诊疗发展': '4'
        }
        return mapping[classify] || '1'
      }

      const targetPath = '/technologyIndex'
      const str = mapFirstClassify(firstClassify)

      if (entrance === '20' || entrance === '21' || entrance === '68') {
        this.$router.replace({
          path: targetPath,
          query: {firstClassify: str}
        })
      } else {
        if (window.history.length > 1) {
          this.$router.back()
        } else {
          this.$router.replace({
            path: targetPath,
            query: {firstClassify: str}
          })
        }
      }
    }
  }
}
export default withRouteTracking(TechnologyDetail)
</script>

<template>
  <div style="width: 100%;" class="technology-detail">
    <img :src="detail && detail.fileUrl" alt="" v-if="isImage">
    <video :src="detail && detail.fileUrl" controls v-if="isVideo"></video>
    <div style="padding: 10px;">
      <VideoPlayerAnswer
        ref="video"
        :playerVideo="videoList[fileId]"
        v-if="videoList[fileId]"
      ></VideoPlayerAnswer>
    </div>
    <img :src="videoList[fileId].bgUrl" alt="" v-if="videoList[fileId]"/>
    <img src="@/assets/images/common/ic_back.png" class="icon-back" alt="" @click.stop="goBack">
    <footerCom :defaultProxyDetails="detail" @handleLike="handleLike" @handleCollect="handleCollect"></footerCom>
  </div>
</template>

<style scoped lang="less">
.icon-back {
  position: fixed;
  z-index: 1000;
  right: 20px;
  bottom: 200px;
  width: 40px;
  display: block;
}

.technology-detail {
  padding-bottom: 70px;
}

img {
  display: block;
  width: 100%;
}

video {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/technology/modules/detail.vue